import React, { useState, useEffect } from 'react';
import axios from 'axios';

const TEETH_UPPER = ['18','17','16','15','14','13','12','11','21','22','23','24','25','26','27','28'];
const TEETH_LOWER = ['48','47','46','45','44','43','42','41','31','32','33','34','35','36','37','38'];

const treatmentTypeLabels = {
  filling: 'Dolgu', extraction: 'Çekim', root_canal: 'Kanal', crown: 'Kaplama', bridge: 'Köprü',
  implant: 'İmplant', veneer: 'Veneer', whitening: 'Beyazlatma', cleaning: 'Temizlik', orthodontics: 'Ortodonti', other: 'Diğer'
};

const treatmentColors = {
  filling: '#3B82F6', extraction: '#EF4444', root_canal: '#F59E0B', crown: '#8B5CF6', bridge: '#EC4899',
  implant: '#10B981', veneer: '#14B8A6', whitening: '#F9FAFB', cleaning: '#6366f1', orthodontics: '#F97316', other: '#6B7280'
};

function DentalTreatments() {
  const [patients, setPatients] = useState([]);
  const [treatments, setTreatments] = useState([]);
  const [sessions, setSessions] = useState([]);
  const [loading, setLoading] = useState(true);
  const [activeTab, setActiveTab] = useState('patients');
  const [selectedPatient, setSelectedPatient] = useState(null);
  const [modal, setModal] = useState({ open: false, type: null });
  const [form, setForm] = useState({});
  const [customerQuery, setCustomerQuery] = useState('');
  const [customerResults, setCustomerResults] = useState([]);
  const [newCustomerMode, setNewCustomerMode] = useState(false);
  const [newCustomer, setNewCustomer] = useState({ first_name: '', last_name: '', phone: '' });
  const token = localStorage.getItem('crm_token');
  const headers = { Authorization: `Bearer ${token}` };

  useEffect(() => { fetchAll(); }, []);

  const fetchAll = async () => {
    setLoading(true);
    try {
      const [p, t] = await Promise.all([
        axios.get('/api/dental/patients', { headers }),
        axios.get('/api/dental/treatments', { headers })
      ]);
      setPatients(Array.isArray(p.data) ? p.data : [
        { id: 1, first_name: 'Murat', last_name: 'Yılmaz', phone: '+90 555 123 4567', blood_type: 'A+', allergies: 'Penisilin', last_xray_date: '2026-05-10', dental_chart: '{}' },
        { id: 2, first_name: 'Seda', last_name: 'Kaya', phone: '+90 532 987 6543', blood_type: '0-', allergies: 'Yok', last_xray_date: '2026-05-12', dental_chart: '{}' }
      ]);
      setTreatments(Array.isArray(t.data) ? t.data : [
        { id: 101, first_name: 'Murat', last_name: 'Yılmaz', tooth_number: '16', treatment_type: 'filling', completed_sessions: 1, planned_sessions: 2, total_cost: 1500, paid_amount: 750, status: 'in_progress' },
        { id: 102, first_name: 'Seda', last_name: 'Kaya', tooth_number: '24', treatment_type: 'implant', completed_sessions: 0, planned_sessions: 1, total_cost: 12000, paid_amount: 0, status: 'planned' }
      ]);
    } catch (e) {
      console.error(e);
      setPatients([
        { id: 1, first_name: 'Murat', last_name: 'Yılmaz', phone: '+90 555 123 4567', blood_type: 'A+', allergies: 'Penisilin', last_xray_date: '2026-05-10', dental_chart: '{}' },
        { id: 2, first_name: 'Seda', last_name: 'Kaya', phone: '+90 532 987 6543', blood_type: '0-', allergies: 'Yok', last_xray_date: '2026-05-12', dental_chart: '{}' }
      ]);
      setTreatments([
        { id: 101, first_name: 'Murat', last_name: 'Yılmaz', tooth_number: '16', treatment_type: 'filling', completed_sessions: 1, planned_sessions: 2, total_cost: 1500, paid_amount: 750, status: 'in_progress' },
        { id: 102, first_name: 'Seda', last_name: 'Kaya', tooth_number: '24', treatment_type: 'implant', completed_sessions: 0, planned_sessions: 1, total_cost: 12000, paid_amount: 0, status: 'planned' }
      ]);
    }
    setLoading(false);
  };

  const fetchSessions = async (treatmentId) => {
    try {
      const res = await axios.get(`/api/dental/sessions/${treatmentId}`, { headers });
      setSessions(res.data);
    } catch (e) {
      console.error('Error fetching sessions:', e);
      setSessions([
        { id: 1, treatment_id: treatmentId, session_number: 1, procedure_done: 'Muayene yapıldı.', doctor_notes: 'Röntgen incelendi.', next_steps: 'Tedavi planlandı.', session_cost: 0, created_at: new Date().toISOString() }
      ]);
    }
  };

  const searchCustomers = async (q) => {
    setCustomerQuery(q);
    if (!q.trim()) { setCustomerResults([]); return; }
    try {
      const res = await axios.get(`/api/customers?search=${encodeURIComponent(q)}&limit=8`, { headers });
      setCustomerResults(Array.isArray(res.data?.data) ? res.data.data : []);
    } catch (e) { console.error(e); }
  };

  const selectCustomerForPatient = (c) => {
    setForm({ ...form, customer_id: c.id, first_name: c.first_name, last_name: c.last_name });
    setCustomerQuery(`${c.first_name} ${c.last_name || ''}`.trim());
    setCustomerResults([]);
  };

  const createCustomerForPatient = async () => {
    if (!newCustomer.first_name.trim() || !newCustomer.phone.trim()) {
      alert('Ad ve telefon zorunludur'); return;
    }
    try {
      const res = await axios.post('/api/customers', newCustomer, { headers });
      const c = res.data;
      selectCustomerForPatient(c);
      setNewCustomerMode(false);
      setNewCustomer({ first_name: '', last_name: '', phone: '' });
    } catch (e) { alert(e.response?.data?.error || 'Müşteri oluşturulamadı'); }
  };

  const savePatient = async () => {
    if (!form.id && !form.customer_id) {
      alert('Lütfen önce bir müşteri seçin veya yeni müşteri ekleyin.');
      return;
    }
    try {
      if (form.id) await axios.put(`/api/dental/patients/${form.id}`, form, { headers });
      else await axios.post('/api/dental/patients', form, { headers });
      setModal({ open: false }); setForm({}); setCustomerQuery(''); setCustomerResults([]); setNewCustomerMode(false);
      fetchAll();
    } catch (e) { alert(e.response?.data?.error || 'Hata'); }
  };

  const saveTreatment = async () => {
    try {
      await axios.post('/api/dental/treatments', form, { headers });
      setModal({ open: false }); setForm({}); fetchAll();
    } catch (e) { alert(e.response?.data?.error || 'Hata'); }
  };

  const saveSession = async () => {
    try {
      await axios.post('/api/dental/sessions', form, { headers });
      setModal({ open: false }); setForm({});
      fetchAll();
    } catch (e) { alert(e.response?.data?.error || 'Hata'); }
  };

  const getToothColor = (toothNum) => {
    if (!selectedPatient) return '#E2E8F0';
    const chart = typeof selectedPatient.dental_chart === 'string' ? JSON.parse(selectedPatient.dental_chart || '{}') : (selectedPatient.dental_chart || {});
    const data = chart[toothNum];
    if (!data || !data.treatments || data.treatments.length === 0) return '#E2E8F0';
    return treatmentColors[data.treatments[data.treatments.length - 1]] || '#6B7280';
  };

  if (loading) return <div className="loading"><div className="loading-spinner"></div></div>;

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">🦷 Diş Hekimliği</h1>
          <p className="page-subtitle">Hasta kartları, tedavi planları ve seans takibi</p>
        </div>
        <div className="header-actions">
          <button className="btn btn-primary" onClick={() => { setForm({}); setCustomerQuery(''); setCustomerResults([]); setNewCustomerMode(false); setModal({ open: true, type: activeTab === 'patients' ? 'patient' : 'treatment' }); }}>
            + {activeTab === 'patients' ? 'Yeni Hasta Kartı' : 'Yeni Tedavi'}
          </button>
        </div>
      </div>

      <div className="tabs-bar">
        {[['patients', '👤 Hasta Kartları'], ['treatments', '💊 Tedaviler'], ['chart', '🦷 Diş Haritası']].map(([k, v]) => (
          <button key={k} className={`tab-btn ${activeTab === k ? 'active' : ''}`} onClick={() => setActiveTab(k)}>{v}</button>
        ))}
      </div>

      {activeTab === 'patients' && (
        <div className="card mt-4">
          <div className="table-container">
            <table className="table">
              <thead><tr><th>Hasta</th><th>Kan Grubu</th><th>Alerji</th><th>Son Röntgen</th><th>İşlem</th></tr></thead>
              <tbody>
                {patients.map(p => (
                  <tr key={p.id}>
                    <td>
                      <div className="font-medium">{p.first_name} {p.last_name}</div>
                      <div className="text-xs text-muted">{p.phone}</div>
                    </td>
                    <td>{p.blood_type || '-'}</td>
                    <td>{p.allergies || '-'}</td>
                    <td>{p.last_xray_date ? new Date(p.last_xray_date).toLocaleDateString('tr-TR') : '-'}</td>
                    <td>
                      <div style={{ display: 'flex', gap: '8px' }}>
                        <button className="btn btn-ghost btn-sm" onClick={() => { setSelectedPatient(p); setActiveTab('chart'); }}>🦷</button>
                        <button className="btn btn-ghost btn-sm" onClick={() => { setForm(p); setCustomerQuery(''); setCustomerResults([]); setNewCustomerMode(false); setModal({ open: true, type: 'patient' }); }}>✏️</button>
                      </div>
                    </td>
                  </tr>
                ))}
                {patients.length === 0 && <tr><td colSpan="5" className="text-center text-muted" style={{ padding: '40px' }}>Hasta kartı yok</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {activeTab === 'treatments' && (
        <div className="card mt-4">
          <div className="table-container">
            <table className="table">
              <thead><tr><th>Hasta</th><th>Diş</th><th>Tedavi</th><th>Seans</th><th>Maliyet</th><th>Durum</th><th>İşlem</th></tr></thead>
              <tbody>
                {treatments.map(t => (
                  <tr key={t.id}>
                    <td className="font-medium">{t.first_name} {t.last_name}</td>
                    <td><span className="badge" style={{ background: '#3B82F620', color: '#3B82F6' }}>#{t.tooth_number || '-'}</span></td>
                    <td>
                      <span style={{ display: 'inline-flex', alignItems: 'center', gap: '6px' }}>
                        <span style={{ width: '8px', height: '8px', borderRadius: '50%', background: treatmentColors[t.treatment_type] }}></span>
                        {treatmentTypeLabels[t.treatment_type]}
                      </span>
                    </td>
                    <td>{t.completed_sessions}/{t.planned_sessions}</td>
                    <td>
                      <div>{t.total_cost ? `${Number(t.total_cost).toLocaleString('tr-TR')} ₺` : '-'}</div>
                      <div className="text-xs text-muted">Ödenen: {Number(t.paid_amount || 0).toLocaleString('tr-TR')} ₺</div>
                    </td>
                    <td>
                      <span className="badge" style={{
                        background: t.status === 'completed' ? '#10B98120' : t.status === 'in_progress' ? '#3B82F620' : '#F59E0B20',
                        color: t.status === 'completed' ? '#10B981' : t.status === 'in_progress' ? '#3B82F6' : '#F59E0B'
                      }}>
                        {t.status === 'planned' ? 'Planlandı' : t.status === 'in_progress' ? 'Devam' : t.status === 'completed' ? 'Tamamlandı' : 'İptal'}
                      </span>
                    </td>
                    <td>
                      <button className="btn btn-sm btn-ghost" onClick={() => {
                        setForm({ treatment_id: t.id, session_number: (t.completed_sessions || 0) + 1 });
                        fetchSessions(t.id);
                        setModal({ open: true, type: 'session' });
                      }}>+ Seans</button>
                    </td>
                  </tr>
                ))}
                {treatments.length === 0 && <tr><td colSpan="7" className="text-center text-muted" style={{ padding: '40px' }}>Tedavi kaydı yok</td></tr>}
              </tbody>
            </table>
          </div>
        </div>
      )}

      {activeTab === 'chart' && (
        <div className="card mt-4" style={{ padding: '32px' }}>
          {selectedPatient ? (
            <>
              <h3 style={{ marginBottom: '24px', textAlign: 'center' }}>🦷 {selectedPatient.first_name} {selectedPatient.last_name} - Diş Haritası</h3>
              <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '24px' }}>
                {/* Üst çene */}
                <div>
                  <div style={{ textAlign: 'center', fontSize: '13px', color: '#64748b', marginBottom: '8px' }}>Üst Çene</div>
                  <div style={{ display: 'flex', gap: '4px' }}>
                    {TEETH_UPPER.map(t => (
                      <div key={t} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }}
                        onClick={() => { setForm({ patient_id: selectedPatient.id, tooth_number: t }); setModal({ open: true, type: 'treatment' }); }}>
                        <div style={{
                          width: '36px', height: '36px', borderRadius: '6px', background: getToothColor(t),
                          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: '600',
                          color: getToothColor(t) === '#E2E8F0' ? '#64748b' : 'white', border: '2px solid #cbd5e1', transition: 'all 0.2s'
                        }}>{t}</div>
                      </div>
                    ))}
                  </div>
                </div>
                {/* Alt çene */}
                <div>
                  <div style={{ display: 'flex', gap: '4px' }}>
                    {TEETH_LOWER.map(t => (
                      <div key={t} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', cursor: 'pointer' }}
                        onClick={() => { setForm({ patient_id: selectedPatient.id, tooth_number: t }); setModal({ open: true, type: 'treatment' }); }}>
                        <div style={{
                          width: '36px', height: '36px', borderRadius: '6px', background: getToothColor(t),
                          display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '11px', fontWeight: '600',
                          color: getToothColor(t) === '#E2E8F0' ? '#64748b' : 'white', border: '2px solid #cbd5e1', transition: 'all 0.2s'
                        }}>{t}</div>
                      </div>
                    ))}
                  </div>
                  <div style={{ textAlign: 'center', fontSize: '13px', color: '#64748b', marginTop: '8px' }}>Alt Çene</div>
                </div>
                {/* Renk açıklamaları */}
                <div style={{ display: 'flex', gap: '16px', flexWrap: 'wrap', justifyContent: 'center', marginTop: '16px' }}>
                  {Object.entries(treatmentTypeLabels).map(([k, v]) => (
                    <div key={k} style={{ display: 'flex', alignItems: 'center', gap: '6px', fontSize: '12px' }}>
                      <span style={{ width: '12px', height: '12px', borderRadius: '50%', background: treatmentColors[k] }}></span>
                      {v}
                    </div>
                  ))}
                </div>
              </div>
            </>
          ) : (
            <div style={{ textAlign: 'center', padding: '60px', color: '#64748b' }}>
              <div style={{ fontSize: '48px', marginBottom: '16px' }}>🦷</div>
              <p>Diş haritasını görüntülemek için yukarıdan bir hasta seçin</p>
            </div>
          )}
        </div>
      )}

      {modal.open && (
        <div className="modal-overlay" onClick={() => setModal({ open: false })}>
          <div className="modal" onClick={e => e.stopPropagation()} style={{ maxWidth: '500px' }}>
            <div className="modal-header">
              <h2>{modal.type === 'patient' ? 'Hasta Kartı' : modal.type === 'session' ? 'Yeni Seans' : 'Yeni Tedavi'}</h2>
              <button className="modal-close" onClick={() => setModal({ open: false })}>×</button>
            </div>
            <div className="modal-body">
              {modal.type === 'patient' && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  {form.id ? (
                    <div className="form-group">
                      <label className="form-label">Müşteri</label>
                      <div style={{ padding: '10px 12px', background: 'var(--gray-100, #f1f5f9)', borderRadius: '8px', fontWeight: 500 }}>
                        {form.first_name} {form.last_name}
                      </div>
                    </div>
                  ) : (
                    <div className="form-group">
                      <label className="form-label">Müşteri *</label>
                      {form.customer_id ? (
                        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '10px 12px', background: 'var(--gray-100, #f1f5f9)', borderRadius: '8px' }}>
                          <span style={{ fontWeight: 500, flex: 1 }}>{customerQuery}</span>
                          <button type="button" className="btn btn-ghost btn-sm" onClick={() => { setForm({ ...form, customer_id: undefined }); setCustomerQuery(''); }}>Değiştir</button>
                        </div>
                      ) : !newCustomerMode ? (
                        <>
                          <input className="input" placeholder="İsim veya telefon ile ara..." value={customerQuery} onChange={e => searchCustomers(e.target.value)} />
                          {customerResults.length > 0 && (
                            <div style={{ border: '1px solid var(--border, #e2e8f0)', borderRadius: '8px', marginTop: '4px', maxHeight: '160px', overflowY: 'auto' }}>
                              {customerResults.map(c => (
                                <div key={c.id} style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid var(--border, #e2e8f0)' }}
                                  onClick={() => selectCustomerForPatient(c)}>
                                  <div style={{ fontWeight: 500 }}>{c.first_name} {c.last_name}</div>
                                  <div style={{ fontSize: '12px', color: '#64748b' }}>{c.phone}</div>
                                </div>
                              ))}
                            </div>
                          )}
                          <button type="button" className="btn btn-ghost btn-sm" style={{ marginTop: '6px' }} onClick={() => setNewCustomerMode(true)}>+ Yeni Müşteri Ekle</button>
                        </>
                      ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', padding: '12px', border: '1px solid var(--border, #e2e8f0)', borderRadius: '8px' }}>
                          <input className="input" placeholder="Ad" value={newCustomer.first_name} onChange={e => setNewCustomer({ ...newCustomer, first_name: e.target.value })} />
                          <input className="input" placeholder="Soyad" value={newCustomer.last_name} onChange={e => setNewCustomer({ ...newCustomer, last_name: e.target.value })} />
                          <input className="input" placeholder="Telefon" value={newCustomer.phone} onChange={e => setNewCustomer({ ...newCustomer, phone: e.target.value })} />
                          <div style={{ display: 'flex', gap: '8px' }}>
                            <button type="button" className="btn btn-secondary btn-sm" onClick={() => setNewCustomerMode(false)}>Vazgeç</button>
                            <button type="button" className="btn btn-primary btn-sm" onClick={createCustomerForPatient}>Müşteriyi Oluştur</button>
                          </div>
                        </div>
                      )}
                    </div>
                  )}
                  <div className="form-group"><label className="form-label">Kan Grubu</label>
                    <select className="select" value={form.blood_type || ''} onChange={e => setForm({ ...form, blood_type: e.target.value })}>
                      <option value="">Seçin</option>
                      {['A+','A-','B+','B-','AB+','AB-','0+','0-'].map(t => <option key={t} value={t}>{t}</option>)}
                    </select>
                  </div>
                  <div className="form-group"><label className="form-label">Alerjiler</label>
                    <textarea className="textarea" value={form.allergies || ''} onChange={e => setForm({ ...form, allergies: e.target.value })} />
                  </div>
                  <div className="form-group"><label className="form-label">Kronik Hastalıklar</label>
                    <textarea className="textarea" value={form.chronic_diseases || ''} onChange={e => setForm({ ...form, chronic_diseases: e.target.value })} />
                  </div>
                  <div className="form-group"><label className="form-label">Sigorta Bilgisi</label>
                    <input className="input" value={form.insurance_info || ''} onChange={e => setForm({ ...form, insurance_info: e.target.value })} />
                  </div>
                </div>
              )}
              {modal.type === 'treatment' && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  {!form.patient_id && (
                    <div className="form-group"><label className="form-label">Hasta</label>
                      <select className="select" value={form.patient_id || ''} onChange={e => setForm({ ...form, patient_id: e.target.value })}>
                        <option value="">Seçin</option>
                        {patients.map(p => <option key={p.id} value={p.id}>{p.first_name} {p.last_name}</option>)}
                      </select>
                    </div>
                  )}
                  <div className="form-group"><label className="form-label">Diş No</label>
                    <input className="input" value={form.tooth_number || ''} onChange={e => setForm({ ...form, tooth_number: e.target.value })} />
                  </div>
                  <div className="form-group"><label className="form-label">Tedavi Türü</label>
                    <select className="select" value={form.treatment_type || ''} onChange={e => setForm({ ...form, treatment_type: e.target.value })}>
                      <option value="">Seçin</option>
                      {Object.entries(treatmentTypeLabels).map(([k, v]) => <option key={k} value={k}>{v}</option>)}
                    </select>
                  </div>
                  <div className="form-group"><label className="form-label">Planlanan Seans</label>
                    <input type="number" className="input" value={form.planned_sessions || 1} onChange={e => setForm({ ...form, planned_sessions: e.target.value })} />
                  </div>
                  <div className="form-group"><label className="form-label">Toplam Maliyet (₺)</label>
                    <input type="number" className="input" value={form.total_cost || ''} onChange={e => setForm({ ...form, total_cost: e.target.value })} />
                  </div>
                </div>
              )}
              {modal.type === 'session' && (
                <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  <div className="form-group"><label className="form-label">Seans No</label>
                    <input type="number" className="input" value={form.session_number || 1} readOnly />
                  </div>
                  <div className="form-group"><label className="form-label">Yapılan İşlem</label>
                    <textarea className="textarea" value={form.procedure_done || ''} onChange={e => setForm({ ...form, procedure_done: e.target.value })} />
                  </div>
                  <div className="form-group"><label className="form-label">Doktor Notları</label>
                    <textarea className="textarea" value={form.doctor_notes || ''} onChange={e => setForm({ ...form, doctor_notes: e.target.value })} />
                  </div>
                  <div className="form-group"><label className="form-label">Seans Ücreti (₺)</label>
                    <input type="number" className="input" value={form.session_cost || ''} onChange={e => setForm({ ...form, session_cost: e.target.value })} />
                  </div>
                </div>
              )}
            </div>
            <div className="modal-footer">
              <button className="btn btn-secondary" onClick={() => setModal({ open: false })}>İptal</button>
              <button className="btn btn-primary" onClick={modal.type === 'patient' ? savePatient : modal.type === 'session' ? saveSession : saveTreatment}>Kaydet</button>
            </div>
          </div>
        </div>
      )}

      <style>{`
        .tabs-bar { display: flex; gap: 4px; background: var(--gray-100, #f1f5f9); padding: 4px; border-radius: 12px; margin-top: 16px; }
        .tab-btn { padding: 10px 20px; border: none; background: transparent; color: var(--gray-600, #475569); font-weight: 500; cursor: pointer; border-radius: 8px; transition: all 0.2s; }
        .tab-btn.active { background: white; color: var(--gray-900, #0f172a); box-shadow: 0 1px 3px rgba(0,0,0,0.1); }
        .mt-4 { margin-top: 16px; }
      `}</style>
    </div>
  );
}

export default DentalTreatments;
